<template>
    <div class="p-5 md:p-[30px]">
        <div class="mt-5" v-for="(schedule, index) in schedules" :key="index">
            <a v-if="index == 0">
                <h3 class="h5">{{schedule.content['title']}}</h3>
                <!-- <span class="caret-down-ico"></span> -->
            </a>
            <a v-else class="pointer" @click="toggle(schedule, index)">
                <h3 class="h5">{{schedule.content['title']}}</h3>
                <span :class="schedule.hide == 0 ? 'caret-down-ico' : 'caret-down-ico'"></span>
            </a>
            <div class="flex justify-between mt-3" v-if="schedule.hide == 0">
                <div class="min-[320px]:max-w-[90px] min-[375px]:max-w-[190px] w-full">
                    <ul>
                        <li v-for="(item, key) in schedule.details" :key="key">
                            <p class="small">{{item.content['title']}}</p>
                        </li>
                    </ul>
                </div>
                <div class="max-w-[190px] w-full">
                    <ul>
                        <li v-for="(item, key) in schedule.details" :key="key">
                            <p class="small" v-if="item.close != true">{{item.start}} - {{item.end}}</p>
                            <p class="small" v-else>Closed</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
  name: 'VetClinicSchedules',

  props: {
    schedules: Array,
  },

  data: () => ({

  }),

  mounted() {

    // console.log(this.menu, this.nav)
    // console.log(this.pathname, ['/services'].indexOf(this.pathname))
  },

  methods: {
    toggle(schedule, index) {
        const schedules = this.schedules;

        if(schedule.hide == 0) {
            console.log(schedules[index]['hide'])

            schedules[index]['hide'] = 1;
        } else {
            console.log('show')
            schedules[index]['hide'] = 0;
        }

        this.schedules = [];
        this.schedules = schedules;
    },
  },
}
</script>

<style scoped>
.pointer {
    cursor: pointer;
}
</style>
